<button class="icon-button" [disabled]="isDisabled" [matTooltip]="tooltip | translate" (click)="buttonClick.emit($event)">
  <i class="material-icons">{{ iconName }}</i>
</button>
